<form [formGroup]="lexiconForm" class="flex-it flex-col">
  <mat-form-field class="pb-3" appearance="fill">
    <mat-label>Word</mat-label>
    <input matInput formControlName="wordControl" />
    @if (wordControl.hasError("required")) {
      <mat-error>Word is <strong>required</strong></mat-error>
    }
  </mat-form-field>
  @if (data.type) {
    <mat-form-field appearance="fill">
      <mat-label>Value</mat-label>
      <mat-select formControlName="valueControl">
        @for (option of valueOptions; track option) {
          <mat-option [value]="option">
            {{ option }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  <button
    mat-raised-button
    color="primary"
    [disabled]="!lexiconForm.valid"
    (click)="confirm()"
    [mat-dialog-close]
  >
    {{ data.title }}
  </button>
</form>
